import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=41e6a25c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=41e6a25c&lang=scss"
import style1 from "./detail.vue?vue&type=style&index=1&id=41e6a25c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e6a25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\oywen\\niehao\\qft\\20260317\\vue-admin-template-master\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e6a25c')) {
      api.createRecord('41e6a25c', component.options)
    } else {
      api.reload('41e6a25c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=41e6a25c&scoped=true", function () {
      api.rerender('41e6a25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessManage/businessList/detail.vue"
export default component.exports